// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__wws3s","button":"footer_button__Isc2m","text":"footer_text__bUuUg","text1":"footer_text1__rHQ_m","cookieSettingsLink":"footer_cookieSettingsLink__OfnRA"};